export default() => {
    const title = document.querySelector<HTMLElement>('.single-product__title');
    const hiddenField = document.querySelector<HTMLInputElement>('input[data-name="producttitle"]');

    if (!title || !hiddenField) {
        return;
    }

    hiddenField.value = title.innerText;
}